<template>
  <div>
    <div class="ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <!-- <pre v-if="isDev" class="form-debug">{{ form }}</pre> -->
          <div ref="stepsBar" class="steps-bar">
            <div
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                'steps-bar__item--last': index >= steps.length - 1,
                'steps-bar__item--active': currentStep >= index + 1,
                'steps-bar__item--current-active': currentStep === index + 1,
              }"
              class="steps-bar__item"
            >
              <div class="steps-bar__item__text">
                <svg class="steps-bar__svg" v-if="(currentStep >= index + 1) && (currentStep !== index + 1)" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33301 10.2612L8.04705 14.9753L17.4751 5.54719" stroke="#9ABBFF" stroke-width="1.3" stroke-linecap="round"/></svg>
              </div>
              <div class="steps-bar__item-dot"><span></span></div>
              <div class="steps-bar__item-line"></div>
            </div>
          </div>

          <div v-if="currentStep === 1" class="step">
            <div v-for="([text, href, linkText], i) in region.headerLinks || []" :key="i" class="region__headerlink">
              {{ text }} <a :href="href">{{ linkText }}</a>
            </div>
            <section>
              <label class="label__tight">{{ region.frequency === 'once' ? t.amountLabel : t.frequency }}</label>
              <div class="donatem__section">
                <div class="donatem__right">
                  <div v-if="region.currencies" class="region__currency">
                    <LazyCurrencySelector :currencies="region.currencies" />
                  </div>
                  <div v-if="region.frequency !== 'once'" class="multiple__payoptions">
                    <NcsyGeneralPaymentsOptions addMonthly :onlyMonthly="region.frequency === 'monthly'" :addSplit="allowSplit" monthesSelector :lang="lang" />
                  </div>
                  <template v-if="referenceCosts.length">
                    <label class="label__tight">{{ t.referenceCosts }}</label>
                    <ul class="region__costs">
                      <li v-for="([amount, label], i) in referenceCosts" :key="i">
                        {{ label }} <span>${{ amount }} - US Dollars</span>
                      </li>
                    </ul>
                  </template>
                  <div class="donateion__list" :class="{ 'donateion__list--full': region.amountSuffix, 'donateion__list--tiers': region.tierCards }">
                    <div :class="{ region__amountrow: region.amountSuffix }">
                      <NcsyGeneralAmounts :monthlyTiers="false" :defaultCheckedAount="defaultAmount" :amountText="t.enterAmount" :hideButtons="!!region.referenceCosts" :includeOther="!region.noOtherAmount" :tierDescriptions="!!region.tierCards" />
                      <span v-if="region.amountSuffix" class="region__amountsuffix">{{ region.amountSuffix }}</span>
                    </div>
                    <ErrorLabel field="amount" />
                  </div>

                  <div v-if="region.receipts" class="region__receipt">
                    <Receipt :receipts="region.receipts" />
                  </div>

                  <template v-if="region.israelDesignation">
                    <label class="label__tight">{{ t.designation }}</label>
                    <div class="ncsydeig__select ncsydeig__select--plain region__ildesignation">
                      <NcsyIsraelDesignation />
                    </div>
                  </template>
                  <template v-else-if="region.designations.length">
                    <label class="label__tight">{{ t.designation }}</label>
                    <div class="ncsydeig__select ncsydeig__select--plain">
                      <FormSelect field="applications.0.campaign">
                        <option v-for="([value, label], i) in region.designations" :key="i" :value="value">{{ label }}</option>
                      </FormSelect>
                    </div>
                    <ErrorLabel field="applications.0.campaign" style="text-align:left" />
                  </template>

                  <template v-if="region.departments">
                    <label class="label__tight">{{ t.chapter }}</label>
                    <div class="ncsydeig__select ncsydeig__select--plain">
                      <FormSelect field="applications.0.department">
                        <option v-for="([value, label], i) in region.departments" :key="i" :value="value">{{ label }}</option>
                      </FormSelect>
                    </div>
                  </template>

                  <div class="dedicate__mobile__info">
                    <div class="transfee" v-if="form.amount">
                      <div v-if="form.amount && form.gateway !== 'check' && form.gateway !== 'wire'">
                        <div class="fee-info-container">
                          <label class="fee-toggle" for="cover">
                            <input
                              id="cover"
                              class="fee-toggle__input"
                              type="checkbox"
                              :checked="form.handleProcessing"
                              @change="setValue('handleProcessing', $event.target.checked)"
                            />
                            <span class="fee-toggle__control" aria-hidden="true">
                              <span>{{ t.yes }}</span>
                            </span>
                            <span class="fee-toggle__copy">
                              {{ t.coverThe }}
                              <MoneyFormat
                                class="amount"
                                :value="parseInt(form.amount) * feePercent / 100"
                                :currencyCode="form.currency"
                              />
                              {{ t.processingFee }}
                            </span>
                          </label>
                          <div
                            class="fee-tooltip-trigger"
                            @mouseenter="showFeeTooltip"
                            @mouseleave="hideFeeTooltip"
                          >
                            <button
                              type="button"
                              class="fee-tooltip-button"
                              aria-describedby="processing-fee-tooltip"
                              :aria-expanded="feeTooltipOpen"
                              @click="toggleFeeTooltip"
                              @focus="showFeeTooltip"
                              @blur="hideFeeTooltip"
                              @keydown.esc="closeFeeTooltip"
                            >
                              {{ t.why }}
                            </button>
                            <div
                              v-show="feeTooltipOpen"
                              id="processing-fee-tooltip"
                              class="fee-tooltip"
                              role="tooltip"
                            >
                              <strong>{{ t.whyFee }}</strong>
                              <p>
                                {{ t.byCovering }} <MoneyFormat
                                  class="amount"
                                  :value="parseInt(form.amount) * feePercent / 100"
                                  :currencyCode="form.currency"
                                /> {{ t.feeHelp }} {{ form.applications[0].department.replace(/_/g, ' ') }} {{ t.feeReceives }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div
              class="step__btn-wrapper"
              v-if="form.amount && Number(form.amount) > 0"
            >
              <div class="btn__blue" @click="goToStep(2)">{{ t.next }}</div>
            </div>

            <a href="/contact" target="_blank" class="contentlink">{{ t.question }}</a>
          </div>

          <div v-if="currentStep === 2" class="step step--lg">
            <div class="steps__infheader">
              <div class="btn__back" @click="goToStep(1)"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0906 4.41058C13.416 4.73602 13.416 5.26366 13.0906 5.58909L8.67981 9.99984L13.0906 14.4106C13.416 14.736 13.416 15.2637 13.0906 15.5891C12.7651 15.9145 12.2375 15.9145 11.912 15.5891L6.91205 10.5891C6.58661 10.2637 6.58661 9.73602 6.91205 9.41058L11.912 4.41058C12.2375 4.08514 12.7651 4.08514 13.0906 4.41058Z" fill="#231F20"/></svg></div>
              <h2>{{ t.personalInfo }}</h2>
              <span></span>
            </div>

            <div class="personal__info" id="personalInfo">
              <FormRow class="personal__firstrow" inline>
                <div class="dform__col">
                  <label>{{ t.title }}
                    <FormSelect field="title" class="personal__title">
                      <option value="">{{ t.title }}</option>
                      <option v-for="([value, label]) in t.titles" :key="value" :value="value">{{ label }}</option>
                    </FormSelect>
                  </label>
                </div>
                <div class="dform__col">
                  <label>{{ t.firstName }} <span class="required">*</span>
                    <FormInput type="text" field="firstName" :flex="1" />
                  </label>
                  <ErrorLabel field="firstName" />
                </div>
                <div class="dform__col">
                  <label>{{ t.lastName }} <span class="required">*</span>
                    <FormInput type="text" field="lastName" :flex="1" />
                  </label>
                  <ErrorLabel field="lastName" />
                </div>
              </FormRow>

              <FormRow class="dform__rowdouble" inline>
                <div class="dform__col">
                  <label>{{ t.email }} <span class="required">*</span>
                    <FormInput type="email" field="email" />
                  </label>
                  <ErrorLabel field="email" />
                </div>
                <div class="dform__col">
                  <label>{{ t.phone }} <span class="required">*</span>
                    <FormCol field="phone" :flex="1" :showLabel="false" class="personal__phone">
                      <PhoneField />
                    </FormCol>
                  </label>
                </div>
              </FormRow>

              <div class="phonec__consent">
                <Consent privacy="https://ncsy.org/privacy-policy/" :lang="lang === 'es' ? 'esp' : undefined" />
              </div>
              <FormRow class="personal__firstrow" inline>
                <div class="dform__col">
                  <label>{{ t.street }} <span class="required">*</span>
                    <FormInput type="text" field="street" :showLabel="false" :flex="1" />
                  </label>
                  <ErrorLabel field="street" />
                </div>
                <div class="dform__col">
                  <label>{{ t.street2 }}
                    <FormInput type="text" field="street2" :showLabel="false" :flex="1" />
                  </label>
                  <ErrorLabel field="street2" />
                </div>
                <div class="dform__col">
                  <label>{{ t.city }} <span class="required">*</span>
                    <FormInput type="text" field="city" :showLabel="false" :flex="1" />
                  </label>
                  <ErrorLabel field="city" />
                </div>
              </FormRow>
              <FormRow class="personal__firstrow" inline>
                <div class="dform__col">
                  <label>{{ t.state }} <span class="required">*</span>
                    <FormSelect field="state" :disabled="form.country !== 'US' && form.country !== 'CA'" :class="{ 'personal__statehide': form.country !== 'US' && form.country !== 'CA' }">
                      <option value="" disabled selected hidden>{{ t.state }}</option>
                      <option v-for="state of stateOptions" :key="state[1]" :value="state[1]">{{ state[0] }}</option>
                    </FormSelect>
                  </label>
                  <ErrorLabel field="state" />
                </div>
                <div class="dform__col">
                  <label>{{ t.zip }} <span class="required">*</span>
                    <FormInput type="text" field="zip" :showLabel="false" :flex="1" />
                  </label>
                  <ErrorLabel field="zip" />
                </div>
                <div class="dform__col">
                  <label>{{ t.country }} <span class="required">*</span>
                    <FormCol
                      class="personal__country"
                      field="country"
                      :showLabel="false"
                      :placeholder="true"
                      :placeholderText="t.country"
                    >
                      <CountrySelector />
                    </FormCol>
                  </label>
                  <ErrorLabel field="country" />
                </div>
              </FormRow>

              <FormRow v-if="region.listingName" class="dform__rowdouble" inline>
                <div class="dform__col">
                  <label>{{ t.listingName }}
                    <FormInput type="text" field="custom.listingName" />
                  </label>
                  <ErrorLabel field="custom.listingName" />
                </div>
                <div class="dform__col">
                  <label>{{ t.dedicationMessage }}
                    <FormInput type="text" field="dedicationMessage" />
                  </label>
                  <ErrorLabel field="dedicationMessage" />
                </div>
              </FormRow>

              <div v-if="!region.hideDedication" class="dedicate__mobile__info">
                <div class="dedicate__modals">
                  <InHonorOf v-if="lang === 'es'" :dedicateLabel="t.dedicate" />
                  <InHonorOf v-else />
                </div>

                <div v-if="!region.hideNotes" class="dedicate__modals">
                  <FormRow>
                    <input type="checkbox" id="note" name="note" v-model="note" />
                    <FormLabel for="note">{{ t.addNote }}</FormLabel>
                  </FormRow>
                  <FormRow inline v-if="note">
                    <FormCol field="custom.Notes" :label="t.message" width="full">
                      <FormInput type="textarea" field="custom.Notes" :placeholder="t.messagePlaceholder" />
                    </FormCol>
                  </FormRow>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentStep === 2" class="step">
            <div class="payment__info" title="Payment Information" last>
              <div class="steps__infheader">
                <span></span>
                <h2>{{ t.paymentInfo }}</h2>
                <span></span>
              </div>

              <div class="payment__cc">
                <FormRow inline>
                  <FormCol
                    class="doublepay"
                    field="card"
                    :showLabel="false"
                    check_text=""
                  />
                </FormRow>
              </div>
            </div>

            <NcsyWestcoastUpsell v-if="showUpsell" @close="closeUpsell" />
            <div class="step__btn-wrapper">
              <button
                type="submit"
                name="submit"
                id="donate-widget-form-submit"
                class="ougiving__btn"
                formnovalidate="formnovalidate"
                @click="onSubmitClick"
              >
                <svg
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="30px"
                  viewBox="0 0 1190.000000 1280.000000"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                    fill="black"
                    stroke="none"
                  >
                    <path
                      d="M5610 11999 c-1096 -88 -1924 -626 -2375 -1544 -80 -162 -155 -347
        -155 -380 0 -8 -4 -15 -8 -15 -4 0 -8 -8 -9 -17 -1 -19 -6 -38 -16 -63 -17
        -47 -78 -287 -91 -360 -3 -19 -8 -46 -11 -59 -2 -14 -7 -47 -10 -74 -3 -28 -8
        -53 -10 -56 -8 -13 -24 -189 -28 -313 -1 -27 -5 -48 -10 -48 -4 0 -3 -9 3 -20
        8 -14 8 -20 0 -20 -7 0 -8 -6 -1 -19 6 -10 8 -21 5 -24 -3 -3 -5 -392 -4 -865
        l1 -860 -26 -20 c-14 -11 -69 -30 -123 -43 -159 -36 -266 -74 -364 -128 -109
        -60 -149 -91 -240 -183 -206 -208 -334 -560 -353 -968 -5 -99 -4 -3022 1
        -3125 8 -175 28 -319 46 -343 7 -8 7 -12 -1 -12 -7 0 -9 -5 -4 -13 4 -6 8 -16
        9 -22 1 -5 11 -34 23 -62 11 -29 17 -53 13 -53 -4 0 -2 -4 3 -8 10 -7 37 -61
        37 -72 0 -3 6 -12 14 -21 8 -9 12 -18 9 -21 -3 -3 6 -17 20 -32 13 -14 25 -29
        25 -31 0 -14 84 -117 122 -150 24 -21 34 -32 23 -24 -18 13 -19 13 -6 -3 7
        -10 17 -18 22 -18 5 0 17 -8 27 -17 39 -37 67 -57 121 -86 175 -94 267 -121
        521 -153 111 -13 461 -15 3121 -14 3106 0 3123 0 3314 39 221 45 397 134 531
        270 161 162 238 342 269 626 12 107 15 407 15 1696 0 862 -2 1573 -4 1580 -3
        8 -7 63 -10 122 -4 60 -8 112 -10 116 -3 4 -7 27 -10 51 -17 143 -76 342 -137
        463 -30 57 -107 176 -138 211 -62 69 -159 160 -174 164 -13 3 -37 30 -38 44 0
        7 -4 4 -8 -7 -8 -19 -8 -19 -15 3 -5 14 -13 21 -21 18 -8 -3 -19 2 -25 10 -7
        8 -19 14 -26 14 -8 0 -14 5 -14 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -9
        10 -20 10 -11 0 -20 5 -20 11 0 5 -4 7 -10 4 -5 -3 -10 -1 -10 5 0 6 -4 8 -10
        5 -5 -3 -10 -2 -10 4 0 5 -8 8 -17 6 -10 -1 -30 4 -45 11 -15 8 -31 13 -35 13
        -4 -1 -16 1 -25 4 -46 18 -54 20 -69 23 -9 2 -27 8 -40 13 -13 5 -27 8 -30 7
        -4 0 -17 8 -30 19 -14 13 -20 14 -15 5 4 -8 -4 -2 -18 13 l-26 28 0 847 c-1
        466 -3 883 -5 927 -7 117 -14 206 -19 240 -3 24 -26 169 -40 255 -21 125 -30
        170 -36 170 -4 0 -6 10 -5 23 1 12 -1 27 -5 32 -5 6 -11 24 -13 40 -9 46 -14
        68 -25 96 -6 15 -8 29 -6 32 3 3 -2 22 -10 42 -9 21 -16 47 -16 59 0 16 -2 18
        -9 7 -7 -10 -11 -1 -16 32 -4 26 -12 47 -17 47 -6 0 -8 9 -5 20 3 11 1 20 -4
        20 -5 0 -9 7 -9 15 0 8 -4 15 -10 15 -5 0 -6 7 -3 17 5 11 3 14 -6 8 -10 -6
        -11 -2 -6 15 5 17 4 21 -5 15 -8 -5 -11 -4 -6 3 7 11 -28 93 -96 227 -22 44
        -55 107 -71 140 -17 33 -34 62 -38 65 -3 3 -16 25 -29 49 -12 24 -26 49 -31
        55 -30 36 -84 113 -105 149 -13 23 -24 38 -24 34 0 -4 -6 -2 -14 5 -8 7 -12
        16 -9 20 2 4 -7 19 -21 33 -15 14 -26 31 -26 37 0 6 -3 8 -7 5 -3 -4 -13 2
        -20 13 -8 11 -19 18 -24 15 -5 -4 -9 2 -9 12 0 11 -20 39 -45 63 -24 24 -42
        47 -39 52 3 4 -4 8 -15 8 -11 0 -22 9 -26 20 -3 11 -13 20 -21 20 -8 0 -14 7
        -14 15 0 8 -7 15 -16 15 -8 0 -12 5 -9 10 3 6 -1 10 -9 10 -9 0 -16 5 -16 11
        0 5 -3 8 -7 6 -5 -3 -14 1 -21 9 -7 8 -9 14 -5 14 4 1 -4 8 -19 16 -16 8 -28
        19 -28 24 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -5 10 -10 10 -6 0 -21 11
        -34 25 -13 14 -26 25 -30 25 -7 0 -67 41 -76 51 -3 3 -19 13 -37 22 -17 9 -37
        22 -45 29 -18 17 -59 42 -143 85 -38 19 -73 40 -76 45 -3 5 -9 9 -12 9 -4 0
        -26 8 -49 18 -374 158 -665 229 -1072 261 -150 12 -504 11 -656 -1z m475
        -1214 c103 -10 140 -15 240 -31 90 -15 283 -67 314 -85 17 -9 74 -31 79 -30
        10 4 273 -148 292 -170 3 -3 23 -18 44 -35 22 -16 49 -38 60 -49 12 -11 35
        -31 51 -43 17 -13 23 -21 15 -17 -8 4 -1 -6 16 -22 27 -24 98 -107 157 -184
        10 -13 27 -40 38 -59 11 -19 28 -48 39 -65 19 -30 73 -126 75 -135 1 -3 10
        -23 20 -45 10 -22 18 -43 17 -47 -1 -5 2 -8 6 -8 5 0 9 -6 10 -12 2 -29 29
        -88 37 -81 4 5 5 3 1 -4 -4 -7 7 -50 23 -97 16 -46 27 -87 24 -90 -3 -3 0 -12
        7 -21 7 -9 10 -18 7 -22 -4 -3 -2 -12 4 -20 9 -10 8 -13 -2 -13 -9 -1 -8 -5 5
        -15 11 -8 15 -15 8 -15 -8 0 -9 -7 -1 -27 6 -16 12 -37 14 -48 8 -49 27 -203
        29 -230 0 -16 5 -33 11 -37 7 -5 6 -8 0 -8 -6 0 -11 -9 -11 -20 0 -11 4 -20 9
        -20 5 0 4 -6 -2 -14 -9 -11 -9 -15 1 -20 10 -5 10 -7 1 -12 -19 -8 -16 -24 5
        -24 10 0 13 -3 6 -8 -16 -10 -18 -222 -3 -222 8 0 9 -4 0 -13 -8 -10 -12 -215
        -13 -707 l-3 -694 -34 -20 c-34 -20 -56 -20 -1717 -24 -1216 -3 -1683 -1
        -1688 7 -4 6 -22 11 -40 11 -69 0 -65 -59 -66 905 -1 479 -1 872 0 875 1 3 3
        32 5 65 4 65 10 117 26 210 6 33 12 71 13 85 2 14 6 32 10 41 4 9 8 27 10 41
        1 13 5 28 8 33 3 6 9 28 13 50 8 42 47 159 71 212 8 17 14 34 14 39 0 33 188
        356 247 424 36 42 197 200 239 235 110 93 398 240 507 259 7 1 28 7 47 14 58
        19 273 52 382 58 57 4 104 7 105 8 4 3 156 -3 218 -9z"
                    />
                  </g>
                </svg>
                <span v-if="processing">
                  <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </span>
                <span v-else class="btnpayment__text">
                  <span v-if="form.dayOfMonth && form.dayOfMonth > 0">{{ t.giveMonthly }}</span>
                  <span v-else>{{ t.donateNow }}</span>
                  <MoneyFormat
                    v-if="form.amount"
                    class="amount"
                    :value="amount"
                    :currencyCode="form.currency"
                    :hideSubunits="Number.isInteger(amount)"
                  />
                </span>
              </button>
            </div>
          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed, nextTick } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'
import { scrollToStepsBar } from '~/shared/scroll-to-steps-bar'
import { formSettings } from '~/form-settings'
import MoneyFormat from '~/components/MoneyFormat.vue'

const states = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Lousiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
]

const provinces = [
  ['Alberta', 'AB'],
  ['British Columbia', 'BC'],
  ['Manitoba', 'MB'],
  ['New Brunswick', 'NB'],
  ['Newfoundland', 'NL'],
  ['Northwest Territories', 'NT'],
  ['Nova Scotia', 'NS'],
  ['Nunavut', 'NU'],
  ['Ontario', 'ON'],
  ['Prince Edward Island', 'PE'],
  ['Quebec', 'QC'],
  ['Saskatchewan', 'SK'],
  ['Yukon', 'YT'],
]

// Per-department settings, copied from each region's live form. Key = form-settings `department`.
type RegionConfig = {
  allowSplit: boolean
  designations: [string, string][]
  // ?campaign=<key> preselects designation <value>
  campaignParams?: Record<string, string>
  // when set, re-derives applications.0.subCampaign on every designation change
  subCampaignFor?: (campaign: string) => string
  // ?utm_content=<one of these> sets applications.0.subCampaign
  utmSubCampaigns?: string[]
  // shows custom.listingName + dedicationMessage
  listingName?: boolean
  currencies?: string[]
  receipts?: string[]
  // uses NcsyIsraelDesignation (custom.designation/subDesignation) instead of designations
  israelDesignation?: boolean
  lang?: 'en' | 'es'
  // [text, href, linkText] rows shown above step 1
  headerLinks?: [string, string, string][]
  // show settings.amounts [amount, label] as an info list; custom amount only
  referenceCosts?: boolean
  // text beside a full-width custom amount input (e.g. 'US Dollars')
  amountSuffix?: string
  // 'monthly' = monthly only, 'once' = one-time only (no frequency toggle)
  frequency?: 'monthly' | 'once'
  // amount buttons only, no custom amount box
  noOtherAmount?: boolean
  // hides step 2 dedication (in honor of) + notes
  hideDedication?: boolean
  // no $36 preselect/prefill (e.g. buttons start above 36)
  noDefaultAmount?: boolean
  // ?designation=<key> switches applications.0.department (see designationDepartments)
  designationParam?: boolean
  // 'Chapter' dropdown setting applications.0.department
  departments?: [string, string][]
  // settings.amounts [amount, html label] as selectable cards showing the label
  tierCards?: boolean
  // hides step 2 notes only (dedication stays)
  hideNotes?: boolean
  // one-time $500 submit opens NcsyWestcoastUpsell ($75/month offer) first
  westcoastUpsell?: boolean
}

// Copied from live ncsy-ny-tjjmoms-eoy (its 'ImpactAccelerator' case never matched the lowercased param, so it is left out).
const designationDepartments: Record<string, string> = {
  communalresearch: 'CommunalResearch',
  communityprojects: 'CommunityProjectsAndPartnerships',
  ifs: 'IsraelFreeSpirit',
  ncsy: 'NCSY',
  advocacy: 'Advocacy',
  relieffunds: 'ReliefFunds',
  ouisrael: 'OUIsrael',
  oupress: 'OUPress',
  jlic: 'JLIC',
  outorah: 'OU_Torah',
  synagogueinitiatives: 'SynagogueInitiatives',
  teachcoalition: 'TeachCoalition',
  yachad: 'Yachad',
  womensinitative: 'WomensInitative',
}

const texts = {
  en: {
    frequency: 'Donation Frequency',
    amountLabel: 'Donation Amount',
    referenceCosts: 'Referencial costs',
    enterAmount: 'Enter amount',
    designation: 'Choose your Designation',
    chapter: 'Chapter',
    yes: 'YES',
    coverThe: 'Cover the',
    processingFee: 'processing fee',
    why: 'Why?',
    whyFee: 'Why is there a fee?',
    byCovering: 'By covering the',
    feeHelp: 'processing fee, you help ensure',
    feeReceives: 'receives 100% of your intended donation.',
    next: 'Next',
    question: 'Have a question about giving? Ask us!',
    personalInfo: 'Personal Information',
    title: 'Title',
    titles: [
      ['Mr', 'Mr.'], ['Mrs.', 'Mrs.'], ['Ms.', 'Ms.'], ['Rabbi', 'Rabbi'], ['Rebbetzin', 'Rebbetzin'],
      ['Rabbanit', 'Rabbanit'], ['Dr.', 'Dr.'], ['Dr. Rabbi', 'Dr. Rabbi'], ['Rabbi Dr.', 'Rabbi Dr.'],
      ['Sir', 'Sir'], ['The honorable', 'The Honorable'], ['Chaplain', 'Chaplain'],
    ],
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    street: 'Street',
    street2: 'Street 2',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    country: 'Country',
    dedicate: 'Dedicate your donation',
    addNote: 'I’d like to add a note',
    listingName: 'Listing name for Dedication',
    dedicationMessage: 'Dedication Message',
    message: 'Message',
    messagePlaceholder: 'Type your message here...',
    paymentInfo: 'Payment Information',
    giveMonthly: 'Give Monthly',
    donateNow: 'Donate Now',
  },
  es: {
    frequency: 'Frecuencia de donación',
    amountLabel: 'Monto de donación',
    referenceCosts: 'Para que te hagas una idea…',
    enterAmount: 'Ingrese el monto',
    designation: 'Elija su designación',
    chapter: 'Capítulo',
    yes: 'SÍ',
    coverThe: 'Cubrir la tarifa de procesamiento de',
    processingFee: '',
    why: '¿Por qué?',
    whyFee: '¿Por qué hay una tarifa?',
    byCovering: 'Al cubrir la tarifa de procesamiento de',
    feeHelp: 'ayuda a que',
    feeReceives: 'reciba el 100% de su donación.',
    next: 'Siguiente',
    question: '¿Tiene alguna pregunta sobre su donación? ¡Escríbanos!',
    personalInfo: 'Información Personal',
    title: 'Título',
    titles: [
      ['Mr', 'Sr.'], ['Mrs.', 'Sra.'], ['Ms.', 'Srta.'], ['Rabbi', 'Rabino'], ['Rebbetzin', 'Rebetzin'],
      ['Rabbanit', 'Rabanit'], ['Dr.', 'Dr.'], ['Dr. Rabbi', 'Dr. Rabino'], ['Rabbi Dr.', 'Rabino Dr.'],
      ['The honorable', 'Honorable'],
    ],
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    street: 'Dirección',
    street2: 'Dirección 2',
    city: 'Ciudad',
    state: 'Estado/Provincia',
    zip: 'Código postal',
    country: 'País',
    dedicate: 'Dedique su donación',
    addNote: 'Información de la dedicación',
    listingName: 'Nombre para la dedicatoria',
    dedicationMessage: 'Dedicatoria',
    message: 'Mensaje',
    messagePlaceholder: 'Escriba su mensaje aquí...',
    paymentInfo: 'Información de pago',
    giveMonthly: 'Donar mensualmente',
    donateNow: 'Donar',
  },
}

const regionConfigs: Record<string, RegionConfig> = {
  NCSY_Midwest: {
    allowSplit: true,
    designations: [
      ['General Donation', 'General Donation'],
      ['End of Year', 'End of Year'],
      ['Fighting Antisemitism', 'Fighting Antisemitism'],
      ['Relief Mission', 'Relief Mission'],
      ['IMO Bella Smith', 'Bella Smith Fund'],
      ['Shabbaton Scholarship', 'Shabbatons'],
      ['TJJ', 'TJJ'],
      ['Rosh Hashana', 'Rosh Hashana/Yom Kippur'],
      ['Purim Donation', 'Purim Donation'],
      ['Alumni Society', 'Alumni Society'],
      ["Manny Gold A'H Fund", 'Manny Gold A"H Fund'],
      ['Torah Fund', 'Torah Fund'],
      ['Scholarships', 'Scholarship Fund'],
      ['Post HS Israel', 'Post High School Israel Scholarship Fund'],
      ['Banquet', 'Banquet Pledge'],
      ['Tammy Kaplan', "Tammy Kaplan A'H Scholarship Fund"],
      ['Scholarships', 'Emanuel and Anita Margulis Scholarship Fund'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
  },
  NCSY_Southern: {
    allowSplit: false,
    designations: [
      ['General Donation', 'General Donation'],
      ['Israel Scholarship', 'Gap Year Scholarship'],
      ['Israel Advocacy', 'Israel Education & Advocacy'],
      ['JSU Donation', 'JSU Clubs'],
      ['F.A.C.T.S. JSU', 'JSU F.A.C.T.S.'],
      ['Scholarship Donation', 'Regional Convention Scholarship'],
      ['Summer Scholarship', 'Israel Travel Scholarships'],
      ['TJJ Donation', 'Lion Alumni Society'],
      ['SOTTampJSUSum', 'Tampa JSU Summit'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
  },
  NCSY_Boston: {
    allowSplit: false,
    designations: [
      ['General Donation', 'General Donation'],
      ["Men's Learning", 'Event Sponsorships'],
      ['Summer Scholarships', 'Summer Scholarships'],
      ['Gap Year Scholarships', 'Gap Year Scholarships'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
  },
  NCSY_CentralEast: {
    allowSplit: false,
    designations: [
      ['General Donation', 'General Donation'],
      ['Cincinnati Donation', 'Cincinnati Donation'],
      ['Columbus Donation', 'Columbus Donation'],
      ['Cleveland Donation', 'Cleveland Donation'],
      ['Detroit Donation', 'Detroit Donation'],
      ['Pittsburgh Donation', 'Pittsburgh Donation'],
      ['Toledo Donation', 'Toledo Donation'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
  },
  NCSY_Southwest: {
    allowSplit: false,
    designations: [
      ['General Donation', 'General Donation'],
      ['Atlanta Donation', 'Atlanta Day School NCSY'],
      ['Austin Donation', 'Austin NCSY'],
      ['Dallas Donation', 'Dallas NCSY'],
      ['Denver Donation', 'Denver NCSY'],
      ['Houston Donation', 'Houston NCSY'],
      ['San Antonio Donation', 'San Antonio NCSY'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
  },
  NCSY_Mexico: {
    allowSplit: false,
    designations: [],
    utmSubCampaigns: ['Direct Mail', 'Telemarketing', 'Text SMS Message'],
    listingName: true,
    amountSuffix: 'US Dollars',
  },
  NCSY_Portland: {
    allowSplit: false,
    designations: [],
  },
  NCSY_Israel: {
    allowSplit: true,
    designations: [],
    currencies: ['USD', 'ILS', 'CAD'],
    receipts: ['us', 'israel', 'canadian'],
    israelDesignation: true,
  },
  NCSY_Argentina: {
    allowSplit: false,
    designations: [],
    lang: 'es',
  },
  NCSY_Chile: {
    allowSplit: false,
    designations: [],
    utmSubCampaigns: ['Direct Mail', 'Telemarketing', 'Text SMS Message'],
    listingName: true,
    referenceCosts: true,
    headerLinks: [
      ['*Para donar con tarjeta Chilena, haz click', 'https://chile.ncsy.org/sumate/', 'aquí'],
      ['*Para español, haz click', 'https://chile.ncsy.org/donate2-latin/', 'aquí'],
    ],
  },
  NCSY_Tristate: {
    allowSplit: true,
    designations: [
      ['General Donation', 'General Donation'],
      ['4G', '4G donation'],
      ['Central and Southern NJ', 'Central and Southern NJ donation'],
      ['Connecticut', 'Connecticut donation'],
      ['Englewood', 'Englewood donation'],
      ['Teaneck', 'Teaneck donation'],
      ['Metrowest NJ', 'Metrowest NJ donation'],
      ['PIVOT', 'Pivot donation'],
      ['JSU Donation', 'JSU Public School Club'],
      ['Summer Scholarship', 'Summer Programs Scholarship'],
      ['Scholarship', 'Regional Convention Scholarship'],
      ['Israel Scholarship', 'Gap Year Scholarship'],
      ['Manhattan Donation', 'Manhattan Donation'],
      ['Riverdale Donation', 'Riverdale Donation'],
      ['Queens', 'Queens Donation'],
      ['Brooklyn Donation', 'Brooklyn/Staten Island Donation'],
      ['Westchester Donation', 'Westchester Donation'],
      ['Long Island Donation', 'Long Island Donation'],
      ['Rockland Donation', 'Rockland County Donation'],
      ['Great Neck', 'Great Neck Donation'],
      ['Fri Night of Inspiration', 'Friday Night of Inspiration'],
      ['TJJ for Moms', 'TJJ For Moms'],
      ['JSU Expansion', 'JSU Expansion'],
      ['Tefillin Campaign', 'Tefillin Campaign'],
    ],
    // Live value is 'TJJ For Moms' (capital F), which matches no option; kept as-is.
    campaignParams: { TJJ: 'TJJ For Moms' },
    subCampaignFor: (campaign) => (campaign === 'Great Neck' || !campaign ? 'GN NCSY Office' : ''),
  },
}

const fallbackRegion: RegionConfig = { allowSplit: false, designations: [['General Donation', 'General Donation']] }

// For forms that share a department but differ (e.g. language); keyed by settings.emailTemplate.
const emailTemplateConfigs: Record<string, RegionConfig> = {
  'ncsy-chile-latin': {
    ...regionConfigs.NCSY_Chile,
    lang: 'es',
    amountSuffix: 'Dólares',
    headerLinks: [
      ['*For english click here', 'https://chile.ncsy.org/donate2/', 'aquí'],
      ['*Para donar con tarjeta chilena, haz click', 'https://chile.ncsy.org/sumate/', 'aquí'],
    ],
  },
}

// For forms that share a department and email template but differ; keyed by form id. Wins over everything.
const formConfigs: Record<string, RegionConfig> = {
  'ncsy-ny-tjjmoms-region': {
    allowSplit: false,
    designations: [],
    frequency: 'monthly',
    noOtherAmount: true,
    hideDedication: true,
  },
  'ncsy-ny-tjjmoms-eoy-region': {
    allowSplit: false,
    designations: [],
    frequency: 'once',
    hideDedication: true,
    designationParam: true,
    noDefaultAmount: true,
  },
  // Chapter dropdown changes the department, so this must not resolve by department.
  'ncsy-westcoast-region': {
    allowSplit: false,
    designations: [
      ['General Donation', 'NCSY'],
      ['JSU Donation', 'JSU'],
      ['Latte & Learning', 'Latte and Learning'],
      ['Scholarships', 'Summer Programs Scholarships'],
      ['NCSY Connect', 'NCSY Connect - Campaign 18'],
      ['JSU Expansion', 'JSU Expansion'],
    ],
    departments: [
      ['NCSY_WestCoast', 'General'],
      ['NCSY_SanDiego', 'San Diego'],
      ['NCSY_Seattle', 'Seattle'],
      ['NCSY_Arizona', 'Arizona'],
      ['NCSY_OrangeCounty', 'Orange County'],
      ['NCSY_Norcal', 'Norcal'],
      ['NCSY_ParkCityUtah', 'NCSY Park City Utah'],
      ['NCSY_LasVegas', 'NCSY Las Vegas'],
      ['NCSY_LAValley', 'NCSY LA Valley'],
      ['NCSY_LACity', 'NCSY LA City'],
    ],
    tierCards: true,
    noDefaultAmount: true,
    hideNotes: true,
    westcoastUpsell: true,
  },
}

export default defineComponent({
  components: {
    MoneyFormat
  },
  setup() {
    const { form, setValue, getValue, submitting, settings, submit } = usePaymentForm()

    const params = queryParams()
    const feePercent = 2.5
    const note = ref(false)
    const feeTooltipOpen = ref(false)
    const feeTooltipPinned = ref(false)
    const currentStep = ref(1)
    const stepsBar = ref<HTMLElement | null>(null)
    const steps = [
      'Donation Amount',
      'Your Info & Payment',
    ]


    const goToStep = async (step: number) => {
      currentStep.value = step
      await nextTick()
      scrollToStepsBar(stepsBar.value)
    }

    const showFeeTooltip = () => {
      feeTooltipOpen.value = true
    }

    const hideFeeTooltip = () => {
      if (!feeTooltipPinned.value) feeTooltipOpen.value = false
    }

    const toggleFeeTooltip = () => {
      feeTooltipPinned.value = !feeTooltipPinned.value
      feeTooltipOpen.value = feeTooltipPinned.value
    }

    const closeFeeTooltip = () => {
      feeTooltipPinned.value = false
      feeTooltipOpen.value = false
    }

    const formId = Object.keys(formSettings).find((id) => formSettings[id] === settings)
    const region = computed(() =>
      (formId ? formConfigs[formId] : undefined)
      ?? (settings?.emailTemplate ? emailTemplateConfigs[settings.emailTemplate] : undefined)
      ?? regionConfigs[form.value.applications?.[0]?.department ?? '']
      ?? fallbackRegion
    )
    const allowSplit = computed(() => region.value.allowSplit)
    const lang = computed(() => region.value.lang ?? 'en')
    const t = computed(() => texts[lang.value])
    const referenceCosts = computed(() => {
      const amounts = settings?.amounts as unknown
      if (!region.value.referenceCosts || !Array.isArray(amounts)) return []
      return amounts.filter((a): a is [number, string] => Array.isArray(a))
    })

    const campaignParam = params.campaign ? region.value.campaignParams?.[String(params.campaign)] : undefined
    if (campaignParam) setValue('applications.0.campaign', campaignParam)

    if (region.value.israelDesignation && !getValue('custom.designation')) {
      setValue('custom.designation', 'General Donation')
    }

    // Live form throws on an unlisted value; here it is just ignored.
    const utmContent = params.utm_content ? String(params.utm_content) : ''
    if (utmContent && region.value.utmSubCampaigns?.includes(utmContent)) {
      setValue('applications.0.subCampaign', utmContent)
    }

    const subCampaignFor = region.value.subCampaignFor
    if (subCampaignFor) {
      watch(
        () => form.value.applications[0].campaign,
        (val) => setValue('applications.0.subCampaign', subCampaignFor(val))
      )
    }

    const designationDepartment = region.value.designationParam && params.designation
      ? designationDepartments[String(params.designation).toLowerCase()]
      : undefined
    if (designationDepartment) setValue('applications.0.department', designationDepartment)

    const defaultAmount = params.amount || region.value.noDefaultAmount ? undefined : '36'

    // Live westcoast: one-time $500 gets a $75/month offer before submitting.
    const showUpsell = ref(false)
    const onSubmitClick = (event: Event) => {
      if (region.value.westcoastUpsell && parseInt(form.value.amount ?? '') === 500 && !form.value.dayOfMonth) {
        event.preventDefault()
        showUpsell.value = true
      }
    }
    const closeUpsell = () => {
      showUpsell.value = false
      submit()
    }

    if (allowSplit.value && params.type === 'split') {
      setValue('dayOfMonth', null)
      setValue('periodMonths', '2')
    }

    if (params.amount) {
      nextTick(() => setValue('amount', params.amount))
      currentStep.value = 2
    }

    watch(
      () => form.value.country,
      () => setValue('state', null)
    )

    const amount = computed(() => {
      const baseAmount = Number(form.value.amount) || 0
      const isHandlingProcessing = Boolean(form.value.handleProcessing)
      const gateway = form.value.gateway
      const transactionFee = Number(form.value.transactionFee) || 2.5

      let calculatedAmount = ['wire', 'check'].includes(String(gateway || ''))
        ? baseAmount
        : isHandlingProcessing
          ? Math.round((baseAmount + baseAmount * transactionFee / 100) * 100) / 100
          : baseAmount

      if (form.value.periodMonths && form.value.dayOfMonth) {
        calculatedAmount *= Number(form.value.periodMonths)
      }

      return calculatedAmount
    })

    const stateOptions = computed(() => {
      if (form.value.country == 'US') return states
      if (form.value.country == 'CA') return provinces
      return []
    })

    return {
      processing: submitting,
      allowSplit,
      lang,
      t,
      referenceCosts,
      region,
      defaultAmount,
      showUpsell,
      onSubmitClick,
      closeUpsell,
      form,
      getValue,
      setValue,
      note,
      amount,
      steps,
      feePercent,
      currentStep,
      stepsBar,
      goToStep,
      stateOptions,
      feeTooltipOpen,
      showFeeTooltip,
      hideFeeTooltip,
      toggleFeeTooltip,
      closeFeeTooltip,
    }
  },
})
</script>
<style scoped lang="scss" src="./ncsy-midwest-region.scss"></style>
<style scoped lang="scss">
:deep(.ncsydeig__select.ncsydeig__select--plain select) {
  padding-left: 12px;
}
.region__amountrow {
  display: flex;
  align-items: center;
  gap: 10px;
  > :first-child {
    flex: 1;
  }
}
.region__amountsuffix {
  font-size: 15px;
  white-space: nowrap;
}
.donateion__list--full :deep(.styled-radio--ou-donation.styled-radio .radio-part) {
  flex: 1 1 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.donateion__list--full :deep(#amount_other_field) {
  width: 100%;
}
.donateion__list--tiers :deep(.styled-radio--ou-donation.styled-radio) {
  align-items: stretch;
}
.donateion__list--tiers :deep(.styled-radio--ou-donation.styled-radio .radio-part) {
  flex: 0 1 calc((100% - 8px) / 2);
  width: calc((100% - 8px) / 2);
  min-width: calc((100% - 8px) / 2);
  max-width: calc((100% - 8px) / 2);
  padding: 0;
  @media (max-width: 480px) {
    flex-basis: 100%;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
// "Other" box spans the full row
.donateion__list--tiers :deep(.styled-radio--ou-donation.styled-radio .radio-part:has(#amount_other_field)) {
  flex-basis: 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.donateion__list--tiers :deep(.styled-radio--ou-donation.styled-radio .radio-part label) {
  height: 100%;
  border-radius: 12px;
  padding: 12px 16px;
  text-align: left;
  justify-content: flex-start;
  align-items: stretch;
  line-height: 1.4;
}
.donateion__list--tiers :deep(.label-description) {
  display: block;
  font-weight: 400;
  font-size: 14px;
  span {
    display: block;
    font-weight: 700;
    font-size: 16px;
  }
}
.donateion__list--tiers :deep(#amount_other_field) {
  width: 100%;
}
.region__headerlink {
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 5px;
}
.region__costs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
  margin: 0 0 16px;
  list-style: none;
  li {
    flex: 1 1 calc(50% - 8px);
    padding: 8px 5px;
    text-align: center;
    border: 1px solid #cacaca;
    border-radius: 8px;
    span {
      display: block;
      font-weight: bold;
    }
  }
}
.region__ildesignation :deep(.designation) {
  gap: 8px;
  select {
    flex: 1;
    min-width: 0;
    max-width: none;
    margin-right: 0;
  }
}
.region__receipt {
  padding-bottom: 22px;
  text-align: left;
  font-family: 'Albert Sans', sans-serif;
  font-size: 14px;
  :deep(.radio-inline input) {
    margin: 0 6px 0 0;
    vertical-align: middle;
  }
  :deep(.israeli-tax-id-row) {
    flex-direction: column;
    align-items: stretch;
    > div {
      padding-right: 0;
    }
    div,
    input {
      width: 100%;
    }
    .control-label {
      width: auto;
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 4px;
    }
  }
}
</style>
